import { render, staticRenderFns } from "./DeploymentServerDetail.vue?vue&type=template&id=52033f9c"
import script from "./DeploymentServerDetail.vue?vue&type=script&lang=js"
export * from "./DeploymentServerDetail.vue?vue&type=script&lang=js"
import style0 from "./DeploymentServerDetail.vue?vue&type=style&index=0&id=52033f9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports